<template>
  <div class="w-full">
    <vs-row vs-justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
        <Default :index="index" :label="$t('MODULE.originDabataseStandar.typeMethod')" option="MethodOrigin"></Default>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
        <Number
          :disabled="false"
          v-model="limit"
          :label="$t('MODULE.originDabataseStandar.limit')"
          :min="1"
          :max="1000"
        ></Number>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
        <vs-button color="success" type="border" @click="OpenPopup()">{{
          $t("MODULE.originDabataseStandar.btnOrigin")
        }}</vs-button>
      </vs-col>
    </vs-row>

    <vs-row class="mt-5" vs-justify="flex-end">
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
        <vs-input
          v-model="questionsByPage[index].properties.originKey"
          :disabled="true"
          class="w-full"
          :label="$t('MODULE.originDabataseStandar.keyCode')"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
        <vs-select
          v-model="questionsByPage[index].properties.searchField"
          autocomplete
          class="w-full px-2"
          :label="$t('MODULE.originDabataseStandar.fieldMainSearch')"
        >
          <vs-select-item :key="index" :value="selector" :text="selector" v-for="(selector, index) in arrayHeaders" />
        </vs-select>
      </vs-col>
    </vs-row>
  </div>
</template>

<script type="text/javascript">
import Default from "../../componentsToQuestions/DefaultSelect.vue";
import Number from "../../components/Number.vue";
import { mapState, mapMutations } from "vuex";
export default {
  props: ["index"],
  components: { Default, Number },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE"]),
    /**
     * Despliega el modal para la selecion del origen de datos.
     */
    OpenPopup() {
      this.UPDATE_STATE({ key: "componentPopup", value: "OriginData" });
      this.UPDATE_STATE({ key: "activePopup", value: true });
      this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
    }
  },
  computed: {
    ...mapState("resource", ["questionsByPage"]),
    /**
     * Obtiene y configura el limite para la busqueda de datos para el origen de datos.
     */
    limit: {
        get() {
            return this.questionsByPage[this.index].properties.limit
        },
        set(newLimit) {
            if(newLimit < 1) return this.questionsByPage[this.index].properties.limit = 1;
            if(newLimit > 1000) return this.questionsByPage[this.index].properties.limit = 1000;
            this.questionsByPage[this.index].properties.limit = newLimit;
        }
    },
    /**
     * Obtiene un array de las cabeceras del origen de datos.
     */
    arrayHeaders() {
      const header = this.questionsByPage[this.index].data;
      if (header[0]) {
        const getKeys = Object.keys(header[0]);
        return getKeys;
      }
      return [];
    }
  }
};
</script>
